import React from 'react';
import { ArrowUpDown, MapPin, Star, MessageSquare } from 'lucide-react';

const SortOptions = ({ sortBy, onSortChange }) => {
  const sortOptions = [
    {
      value: 'distance',
      label: 'Distance',
      icon: MapPin,
      description: 'Closest landmarks first'
    },
    {
      value: 'rating',
      label: 'Rating',
      icon: Star,
      description: 'Highest rated first'
    },
    {
      value: 'reviews',
      label: 'Reviews',
      icon: MessageSquare,
      description: 'Most reviewed first'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <div className="flex items-center space-x-2 mb-3">
        <ArrowUpDown className="w-5 h-5 text-gray-600" />
        <span className="text-sm font-medium text-gray-900">Sort by</span>
      </div>
      
      <div className="grid grid-cols-3 gap-2">
        {sortOptions.map((option) => {
          const Icon = option.icon;
          const isSelected = sortBy === option.value;
          
          return (
            <button
              key={option.value}
              onClick={() => onSortChange(option.value)}
              className={`p-3 rounded-lg border text-center transition-all ${
                isSelected
                  ? 'border-indigo-500 bg-indigo-50 text-indigo-700'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <Icon className={`w-5 h-5 mx-auto mb-1 ${isSelected ? 'text-indigo-600' : 'text-gray-500'}`} />
              <div className="text-xs font-medium">{option.label}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SortOptions;
